// extracted by mini-css-extract-plugin
export default {"wrapper":"PageHome_wrapper__AEgGg"};